import { ICurrentUser } from 'types/income';
// keep this to avoid circular dependency
import { convertParentCompany } from 'store/companies/companies.converters';
import { convertAdminRole } from 'store/permissions';
import { loaders } from './auth.loaders';
import { CurrentUser } from './auth.types';

const convertCurrentUser = (user: ICurrentUser): CurrentUser => {
  return {
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    phone: user.phone,
    role: user.role,
    root: user.root,
    status: user.status,
    creationDate: user.creationDate,
    language: user.language,
    parentCompany: user.parentCompany
      ? convertParentCompany(user.parentCompany)
      : null,
    permissions: user.permissions,
    adminPermissions: user.melpPermissions,
    adminRole: user.adminRole ? convertAdminRole(user.adminRole) : null,
    permissionScopes: user.permissionScopes ?? [],
    activeEmployeesCount: user.activeEmployeesCount,
    companyScopeEmployeesCount:
      user.companyScopeEmployeesCount == null ||
      user.companyScopeEmployeesCount === user.activeEmployeesCount
        ? null
        : user.companyScopeEmployeesCount,
  };
};

export const converters = {
  getCurrentUser: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getCurrentUser>>) => {
    return convertCurrentUser(data);
  },
  getAuthProvider: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getAuthProvider>>) => {
    return data;
  },
};
